export const ERROR_ACTION = '@@NGX_UTILS/API_ERROR';
